export default __webpack_public_path__ + "static/media/37.61e0f11e.png";